import React, { FC, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { navigate } from 'gatsby';
import { Role_Enum } from 'generated/graphql';
import { Layout } from 'components/layout';
import { useAuthContext } from 'components/authorization/AuthProvider';
import { AuthDisplayState } from 'components/authorizationPopups';
import { Landing } from 'components/Landing';

const title = 'Vansanity';

type Props = Record<string, never>;

const Home: FC<Props> = () => {
  const { authUserPromise } = useAuthContext();
  const [authModalDisplay, setAuthModalDisplay] = useState(
    AuthDisplayState.Disabled,
  );

  const [userRole, setUserRole] = useState<Role_Enum | 'NoUser'>();
  const [userName, setUserName] = useState<string>('');

  useEffect(() => {
    authUserPromise()
      .then((user) => {
        if (user.role == Role_Enum.Provider) {
          // The only web page for providers is managing their own payment methods
          navigate('/app/payment-methods');
          return;
        }
        setUserRole(user.role);
        setUserName(user.firstName);
      })
      .catch(() => {
        setUserRole('NoUser');
      });
  }, [authUserPromise]);

  if (!userRole) {
    // Still waiting to see what Role we are, if any so no display
    return <div />;
  }

  // Admin/manager so can see the real Home

  return (
    <Layout
      authModalDisplay={authModalDisplay}
      setAuthModalDisplay={setAuthModalDisplay}
    >
      <Helmet
        htmlAttributes={{
          lang: 'EN',
        }}
        title={title}
        titleTemplate={title}
      ></Helmet>
      <Landing
        message={
          userRole === 'NoUser'
            ? 'Please login to proceed to the admin panel'
            : `Welcome, ${userName}`
        }
        onLogin={
          userRole === 'NoUser'
            ? () => setAuthModalDisplay(AuthDisplayState.SignIn)
            : undefined
        }
      />
    </Layout>
  );
};

export default Home;
